import { Button, Select, Checkbox, Form, Input, Modal, Space, Alert, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { editQuiz, toggleModal } from "../../../features/quizzes/quizzesSlice";
import { useEffect } from "react";
import { useGetVideosQuery } from "../../../features/videos/videosApi";
import { CloseCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useAddQuizMutation, useEditQuizMutation, useGetQuizzesQuery } from "../../../features/quizzes/quizzesApi";
const { TextArea } = Input;

export default function QuizForm() {
  const dispatch = useDispatch()
  const [form] = Form.useForm();

  const { data: videos } = useGetVideosQuery()
  const { openModal, quiz } = useSelector(state => state.quizzes)

  const [addQuiz, { isLoading, isError, error, data }] = useAddQuizMutation();
  const [updateQuiz, { isLoading: isUpdating, isError: updateIsError, error: updateError, data: updatedData }] = useEditQuizMutation();

  const submitHandler = (data) => {
    const video_title = videos?.find(v => v?.id == data?.video_id)?.title || '';
    if (!video_title) {
      message.error('Internal server error!!!')
      return;
    };
    try {
      if (quiz && quiz?.id) {
        updateQuiz({ id: quiz?.id, data: { ...data, video_title } })
      } else {
        const createdAt = new Date().toISOString()
        addQuiz({ ...data, createdAt, video_title })
      }
      cancelHandler()

    } catch (error) {

    }
  }

  const cancelHandler = () => {
    dispatch(toggleModal(false))
    form.resetFields()
    dispatch(editQuiz({}))
  }

  useEffect(() => {
    if (quiz && Object.entries(quiz).length) {
      form.setFieldsValue({ ...quiz })
    } else {
      form.resetFields()
    }
  }, [quiz, form])

  const title = quiz && quiz?.id ? 'Update Quiz' : 'Add New Quiz';

  const handleAdd = () => {
    const currentFieldsValue = form.getFieldsValue();
    const { options = [] } = currentFieldsValue || {};
    const max_id = options?.length ? Math.max(...options?.map(o => +o.id)) : 0;
    options.push({ isCorrect: false, id: max_id + 1 })

    form.setFieldsValue({ ...currentFieldsValue, options })
  };

  return (
    <Modal open={openModal} title={title}
      centered
      footer={false}
      onCancel={cancelHandler}>
      {
        !videos?.length ?
          <Alert type="error" message="Error" description="No Videos Found! Please add a video first!" />
          :

          <Form onFinish={submitHandler} form={form} layout="vertical">
            <Form.Item label="Question" name="question" rules={[{ required: true, message: 'Question is required' }]}>
              <Input />
            </Form.Item>
            <Form.Item label="Select Video" name="video_id" rules={[{ required: true, message: 'Select a video' }]}>
              <Select
                options={videos}
                fieldNames={{ label: 'title', value: 'id' }}
              />
            </Form.Item>

            <Form.List
              name="options"
              rules={[
                {
                  validator: async (_, options) => {
                    if (!options || options.length < 2) {
                      return Promise.reject(new Error('At least 2 options'));
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div className="flex  gap-2" align="baseline" style={{ width: '100%' }} >

                      <Form.Item hidden name={[name, 'id']} />
                      <Form.Item style={{ width: '70%' }} label="Option Value" name={[name, 'option']} validateTrigger={['onChange', 'onBlur']} rules={[{ required: true, message: 'option is required' }]}>
                        <TextArea placeholder="option value" />
                      </Form.Item>

                      <Form.Item valuePropName="checked" label="Is correct?" name={[name, 'isCorrect']} >
                        <Checkbox />
                      </Form.Item>

                      {fields.length > 1 ? (
                        <Form.Item label="Remove">
                          <CloseCircleOutlined style={{ color: 'red' }} onClick={() => remove(name)} />
                        </Form.Item>
                      ) : null}

                    </div>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => handleAdd()}
                      style={{ width: '30%' }}
                      icon={<PlusOutlined />}
                    >
                      Add Option
                    </Button>

                    <Form.ErrorList errors={errors} />
                  </Form.Item>
                </>
              )}

            </Form.List>
            <Form.Item className="flex justify-end">
              <Space>
                <Button onClick={cancelHandler}>Cancel</Button>
                <Button type="primary" htmlType="submit">Submit</Button>
              </Space>
            </Form.Item>
          </Form>
      }
    </Modal>
  )
}